import { boardTodo, type BoardPick } from '../logic/dashboard';

interface BoardTodoLineProps {
  filters?: unknown[];
  selected?: Record<string, string[]>;
  onPick: (pick: BoardPick) => void;
}

// The status region stays mounted, empty when nothing is picked, so each change is announced.
export default function BoardTodoLine({ filters = [], selected = {}, onPick }: BoardTodoLineProps) {
  const todo = boardTodo(selected, filters);
  return (
    <div role="status" className="board-todo">
      {todo && (
        <div className="board-todo__line">
          <span className="board-todo__title">{todo.label}</span>
          {todo.count !== null && (
            <span className="board-todo__count">{todo.count === 1 ? '1 patient' : `${todo.count} patients`}</span>
          )}
          <span className="board-todo__text">
            <strong>To do · </strong>
            {todo.text}
          </span>
          <button
            type="button"
            className="filter-clear"
            aria-label={`Clear filter: ${todo.label}`}
            onClick={() => onPick({ key: todo.key, value: todo.value })}
          >
            Clear
          </button>
        </div>
      )}
    </div>
  );
}
